import { BarController } from 'chart.js';
import { get } from 'lodash';

const gridLineColor = '#4e525a';

class CustomBarController extends BarController {

    draw() {
        let chart = this.chart;
        let chartContext = this.chart.ctx;
        var xScale = this.chart.scales['x'];
        var yScale = this.chart.scales['y'];

        // hide tick lines and draw custom ones
        if (yScale !== undefined) {
            const leftX = yScale.left;
            const rightX = yScale.right;

            yScale.options.grid.display = false;
            yScale.ticks.forEach((label, index) => {
                const tickPos = yScale.getPixelForTick(index);

                chartContext.save();
                chartContext.beginPath();

                if (label !== '' && label != '0' && label != '$0') {
                    chartContext.moveTo(xScale.left, tickPos);
                    chartContext.lineTo(xScale.right, tickPos);
                    chartContext.strokeStyle = gridLineColor;
                }

                chartContext.lineWidth = 1;
                chartContext.stroke();
                chartContext.restore();
            });
        }

        //draw the average
        let dailyGoal = get(this, '_cachedMeta._dataset.dailyGoal', 0);

        if (dailyGoal != 0 && xScale && yScale) {
            // find the actual position of the 'goal' dataset?
            let yPos = yScale.getPixelForValue(dailyGoal);
            //let yPos = Math.round(yScale.height - ((dailyGoal / yScale.max) * yScale.height)*.975);
            this.chart.ctx.beginPath();
            this.chart.ctx.moveTo(Math.round(xScale.left), yPos);
            this.chart.ctx.strokeStyle = '#66FFCC';
            this.chart.ctx.lineWidth = 1;
            this.chart.ctx.lineTo(Math.round(xScale.right), yPos);
            this.chart.ctx.stroke();
        }

        super.draw(arguments);

        // draw bottom bar
        this.chart.ctx.beginPath();
        this.chart.ctx.moveTo(Math.round(xScale.left), yScale.bottom);
        this.chart.ctx.strokeStyle = '#ffffff';
        this.chart.ctx.lineWidth = 1;
        this.chart.ctx.lineTo(Math.round(xScale.right), yScale.bottom);
        this.chart.ctx.stroke();
    }
}
CustomBarController.id = 'CustomBar';
CustomBarController.defaults = BarController.defaults;

export default CustomBarController;